import { common_axios } from "../App";

export const otpGenerate = async (payload) => {
  try {
    let res = await common_axios.post(`/auth/v1/otp/generate`, payload, {
      skipAuth: true,
    });
    return res;
  } catch (e) {}
};

export const otpVerify = async (payload) => {
  try {
    let res = await common_axios.post(`/auth/v1/otp/verify`, payload, {
      skipAuth: true,
    });
    return res;
  } catch (e) {}
};

// export const otpVerify = async (payload) => {
//   try {
//     await common_axios.post(`/auth/v1/otp/verify`, payload);
//   } catch (e) {}
// };

export const forgotPassword = async (payload) => {
  try {
    let res = await common_axios.get(
      `/auth/v1/forgot/password/` + payload?.email,
      { skipAuth: true }
    );
    return res;
  } catch (e) {}
};

export const validateLinkPassword = async (payload) => {
  try {
    let res = await common_axios.post(
      `/auth/v1/verify/password/change`,
      { skipAuth: true },
      payload
    );
    return res;
  } catch (e) {}
};
export const logout = async (payload) => {
  try {
    let res = await common_axios.post(`/auth/v1/otp/verify`, payload, {
      skipAuth: true,
    });
    return res;
  } catch (e) {}
};
